import { lightTheme } from "@/customTheme"
const SvgComponent = ({ color = lightTheme.colors.blackGray, ...props }) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 0.799805C11.9764 0.799816 15.2002 4.02357 15.2002 8C15.2002 11.9764 11.9764 15.2002 8 15.2002C4.02357 15.2002 0.799816 11.9764 0.799805 8C0.799805 4.02356 4.02356 0.799805 8 0.799805Z"
      stroke={color}
      strokeWidth={1.6}
    />
    <path
      d="M8.00019 7.19995V11.1999"
      stroke={color}
      strokeWidth={1.6}
      strokeLinecap="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00019 5.6C8.44202 5.6 8.80019 5.24182 8.80019 4.8C8.80019 4.35817 8.44202 4 8.00019 4C7.55837 4 7.2002 4.35817 7.2002 4.8C7.2002 5.24182 7.55837 5.6 8.00019 5.6Z"
      fill={color}
    />
  </svg>
)
export default SvgComponent
